// Get base URL from environment or use current origin with fallback port
const getBaseUrl = () => {
  console.log(`🔧 Determining API base URL...`);
  
  // W środowisku DEV używaj nginx proxy, nie bezpośredniego połączenia z backendem
  const apiUrl = window.location.origin;
  console.log(`🔧 Using nginx proxy URL: ${apiUrl}`);
  
  // Dodaj więcej logowania
  console.log(`🔧 Final API URL will be: ${apiUrl}/api`);
  
  return apiUrl;
};

const API_BASE_URL = getBaseUrl();

console.log(`🔧 Final API base URL: ${API_BASE_URL}`);
console.log(`🔧 Browser location:`, {
  origin: window.location.origin,
  hostname: window.location.hostname,
  protocol: window.location.protocol,
  port: window.location.port,
});

export default {
  API_BASE_URL,
  VERSION: '1.0.1', // Dodana wersja konfiguracji
};
